import { render } from "./PlayerList.vue?vue&type=template&id=19759583&scoped=true"
import script from "./PlayerList.vue?vue&type=script&lang=js"
export * from "./PlayerList.vue?vue&type=script&lang=js"

import "./PlayerList.vue?vue&type=style&index=0&id=19759583&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19759583"]])

export default __exports__